import { mailMeFields } from "./mailMeConfig";

const dayMs = 24 * 60 * 60 * 1000;

export const mailMeValueFieldNames = Object.freeze(mailMeFields.map(field=>field.name));
export const getMuteFieldName = fieldName=>`${fieldName}MuteTill`;
export const mailMeMuteFieldNames = Object.freeze(mailMeValueFieldNames.map(getMuteFieldName));
export const mailMeFieldNames = Object.freeze([...mailMeValueFieldNames, ...mailMeMuteFieldNames]);

export const getActiveMuteTill = (value, now)=>{
    if (!value) { return null; }

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime()) || date.getTime() <= now) { return null; }

    return date;
};

export const formatMuteDaysLeft = (say, date, now)=>{
    const days = Math.max(1, Math.ceil((date.getTime() - now) / dayMs));
    return say.unit("day", days);
};

export const createMailMeValues = (profile={})=>{
    const now = Date.now();
    return Object.fromEntries(mailMeFields.flatMap(field=>{
        const muteField = getMuteFieldName(field.name);
        return [
            [field.name, profile[field.name] != false],
            [muteField, getActiveMuteTill(profile[muteField], now)]
        ];
    }));
};
